import type { FailedNotificationTasksParams } from 'api/highnote/notificationTasks'

const failedNotificationTasksRoot = [
  'highnote',
  'notification-tasks',
  'failed',
] as const

export const highnoteKeys = {
  all: ['highnote'] as const,
  tokenizationClientToken: () =>
    [...highnoteKeys.all, 'tokenizationClientToken'] as const,
  failedNotificationTasksRoot,
  failedNotificationTasks: (params: FailedNotificationTasksParams) =>
    [...failedNotificationTasksRoot, params] as const,
  errorCodes: () => [...highnoteKeys.all, 'errorCodes'] as const,
}
